import React, { Component } from 'react';
import DescriptiveText from './components/descriptiveText.js';
import CustomerHero from './components/customerHero';
import WebscreenSingle from './components/webscreenSingle';
import WebscreenDouble from './components/webscreenDouble';
import WebscreenMobile from './components/webscreenMobile';
import FullWidthImage from './components/fullWidthImage';
import CustomerQuote from './components/customerQuote';
import Footer from "./components/footer";

export default class Hyperlite extends Component {
  constructor(props) {
      super(props);
      this.state = {
  			animations: []
  		};
  }
  componentDidMount() {
  }
  render() {
    return (
      <div>
        <CustomerHero company="Hyperlite"
          title="Pushing the limits of what is possible in the world of wakeboarding"
          video=""
          backgroundImage="images/hyperlite-hero.jpg"
          overlayColor="#009ba5"
        />
        <div className="white-background large-margin-top">
            <DescriptiveText
              title="Company Overview"
              text="Hyperlite is a leading manufacturer of high-quality wakeboards and wakesurfers and one of the most dynamic companies in the watersports industry."
            />
			<WebscreenSingle
			  image="images/hyperlite-long.jpg"
			/>
            <DescriptiveText
              title="Cutting-edge Design for a Game-changing Brand"
              text="Alpine Design worked closely with Hyperlite to execute a website that incorporated Hyperlite's strong brand image, a visually-rich design, and intuitive e-commerce abilities."
            />
            <WebscreenDouble
              image1="images/hyperlite-side-by-side-1.jpg"
              image2="images/hyperlite-side-by-side-2.jpg"
            />
            <DescriptiveText
              title="Responsive Results"
              text="With so many users visiting their site on mobile devices, it was imperative that Hyperlite's website was optimized for any device or screen size. Alpine Design built the website on the foundation of responsive development to ensure it would look and work great no matter how or where it was viewed."
            />
            <WebscreenMobile
              image1="images/hyperlite-mobile-1.png"
              image2="images/hyperlite-mobile-2.png"
              image3="images/hyperlite-mobile-3.png"
            />
			<DescriptiveText
              title="School's Out For Summer"
              text="With hundreds of retailers all over the world, Hyperlite needed a training tool that could effectively educate their dealers about Hyperlite products. We developed Shreducation- an interactive learning platform complete with quizzes, videos, and of course, awesome swag to keep dealers informed of their products' latest features."
            />
			<div className="max-width-container">
				<FullWidthImage
				  image="images/hyperlite-shreducation.jpg"
				/>
			</div>
			<DescriptiveText
				  title="A Graphic Board Meeting"
				  text="One of the design-centric projects we do annually for Hyperlite is the design of a full line of wakeboards sold at WiredSport, a Hyperlite co-op. This is a fun and challenging project for the Alpine Design team to flex our creative muscles in the best way possible. "
				/>
			<div className="max-width-container">
				<FullWidthImage
				  image="images/hyperlite-board-graphics.jpg"
				/>
			</div>
            <DescriptiveText
              title="Hyperlite TV"
              text="Hyperlite has an abundance of creative video content from their professional team riders and wakeboard enthusiasts alike. Alpine Design developed Hyperlite TV as a way to keep visitors engaged with a multi-platform viewing experience."
            />
			<div className="max-width-container">
				<FullWidthImage
				  image="images/hyperlite-tv.jpg"
				/>
			</div>
        </div>
		<CustomerQuote
              thumb="images/hyperlite-quote-thumb.jpg"
              name="Greg Nelson, VP of Marketing, Hyperlite Wakeboards"
              overlayColor="#009ba5"
              quote="Our websites are the most important parts of our marketing strategy- they invite consumers into our world so they can better know our brands. It's open all day everyday and it's critical to successful brand building. Alpine Design was (and is) as passionate about our brands as I am.  Our previous website was stale, tough to update and manage, and didn't tell our story. Alpine Design has changed all that!"
              backgroundImage="images/hyperlite-quote-background.jpg"
            />
        <Footer />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/hyperlite.js